<template>
    <div style="padding-bottom: 55px">
        <div v-show="isFirst">
            <div style="margin-top: 20px;">
                <el-row :gutter="12">
                    <el-col :span="8">
                        <el-select v-model="statusSelect" @change="statusChange" style="width: 110px;">
                            <el-option label="全部状态" value="0"></el-option>
                            <el-option label="审批中" value="1"></el-option>
                            <el-option label="审批通过" value="2"></el-option>
                            <el-option label="审批拒绝" value="3"></el-option>
                            <el-option label="已发货" value="4"></el-option>
                        </el-select>
                        <el-button :loading="loadingForConfirm" @click="allConfirm(true)" type="success" style="margin-left: 3px;" v-if="isBrand">批准
                        </el-button>
                        <el-button :loading="loadingForConfirm" @click="allConfirm(false)" type="danger" style="margin-left: 3px;" v-if="isBrand">拒绝
                        </el-button>
                        <el-button @click="readyNewAccount" type="primary" style="margin-left: 3px;" v-if="isAgent">新增开单
                        </el-button>
                    </el-col>
                    <el-col :span="16">
                        <div style="width: 100%;text-align: right;">
                            <el-select style="width: 110px;margin-left: 3px;" v-model="selectValue" placeholder="请选择">
                                <el-option label="代理商" value="1" v-if="isBrand"></el-option>
                                <el-option label="联系人" value="2"></el-option>
                                <el-option label="客户名称" value="3"></el-option>
                                <el-option label="开单号" value="4"></el-option>
                                <el-option label="开单日期" value="5"></el-option>
                                <el-option label="安装地址" value="6"></el-option>
                            </el-select>
                            <el-input type="text" style="width:255px;margin-left: 3px;" v-model="queryValue"
                                      v-if="isInput" placeholder="请输入"></el-input>
                            <el-date-picker style="width: 255px;margin-left: 3px;" v-if="!isInput" v-model="time"
                                            type="daterange" range-separator="至" start-placeholder="订单开始日期"
                                            end-placeholder="订单结束日期" format="yyyy-MM-dd"></el-date-picker>
                            <el-button type="primary" style="margin-left: 3px;" icon="el-icon-search"
                                       @click="updateTable">搜索</el-button>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div style="margin-top: 10px;">
                <el-table ref="multipleTable" :data="tableData" style="width: 100%" element-loading-text="数据正在加载中"
                          @selection-change="handleSelectionChange"
                          :row-style="rowClass">
                    <el-table-column type="selection" width="60"></el-table-column>
                    <el-table-column prop="id" label="开单号" sortable></el-table-column>
                    <el-table-column prop="adminName" label="代理商" v-if="isBrand"></el-table-column>
                    <el-table-column label="状态">
                        <template slot-scope="scope">
                            <div>
                                <span v-if="scope.row.status == 1">审批中</span>
                                <span v-if="scope.row.status == 2">审批通过</span>
                                <span v-if="scope.row.status == 3">审批拒绝</span>
                                <span v-if="scope.row.status == 4">已发货</span>
                                <span v-if="scope.row.status == 5">已取消</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="customerName" label="客户名称"></el-table-column>
                    <el-table-column prop="contact" label="联系人"></el-table-column>
                    <el-table-column prop="contactNumber" label="联系电话"></el-table-column>
                    <el-table-column label="安装地址">
                        <template slot-scope="scope">
                            <div>{{scope.row.province}} {{scope.row.city}} {{scope.row.district}} {{scope.row.address}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="posttime" label="开单日期" :formatter="dateFormat"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <button @click="getMessage(scope.row)">详情</button>
                            <button @click="cancelAccount(scope.row)"
                                    v-if="isAgent && scope.row.status == '1'">取消</button>
                            <button @click="returnAccount(scope.row)"
                                    v-if="isAgent && scope.row.status == '4'">退单</button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination background style="text-align:right;margin-top: 15px;margin-bottom: 65px;"
                               @size-change="handleSizeChange" @current-change="handleCurrentChange"
                               :current-page="currentPage" :page-sizes="[10, 50, 100, 200]" :page-size="pageSize"
                               layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
            </div>
        </div>
        <div v-show="!isFirst">
            <div style="margin-top: 20px;">
                <i class="el-icon-back" style="font-size: 16px;cursor:pointer;" @click="goback">{{title}}</i>
            </div>
            <div style="margin-top: 25px;">
                <el-row>
                    <el-col :span="18">
                        <div v-if="isNew || isUpdate">
                            <el-form label-position="right" label-width="120px" ref="accountNewForm"
                                     :rules="accountNewRules" :model="accountNewForm">
                                <el-form-item label="开单类型" prop="businessModel" v-if="!isUpdate">
                                    <!-- <el-select @change="switchModel" v-model="accountNewForm.businessModel" type="text" style="width: 180px;">
                                        <el-option label="租赁模式" :value="0" />
                                        <el-option label="共享模式" :value="1" />
                                        <el-option label="共享(发展水平)" :value="4" />
                                    </el-select> -->
                                    <el-select @change="switchModel" v-model="accountNewForm.businessModel" type="text"
                                               style="width: 180px;">
                                        <el-option :key="item.businessModel" v-for="item in businessModelList"
                                                   :label="item.description" :value="item.businessModel"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="公司名称" prop="customerName">
                                    <el-input v-model="accountNewForm.customerName" type="text" style="width: 180px;">
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="联系人" prop="contact">
                                    <el-input v-model="accountNewForm.contact" type="text" style="width: 180px;">
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="联系电话" prop="contactNumber">
                                    <el-input v-model="accountNewForm.contactNumber" type="text" style="width: 180px;">
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="安装省市区" prop="selectList">
                                    <el-cascader :options="addressList" style="width: 240px;" :props="commodityProps"
                                                 v-model="accountNewForm.selectList" @change="handleChange">
                                    </el-cascader>
                                </el-form-item>
                                <el-form-item label="安装详细地址" prop="address" v-if="accountNewForm.businessModel!=4">
                                    <el-input v-model="accountNewForm.address" type="textarea" :rows="3"
                                              style="width: 240px;"></el-input>
                                </el-form-item>
                                <el-form-item label="安装详细地址" prop="placementId" v-if="accountNewForm.businessModel==4">
                                    <el-select @change="switchModel" v-model="accountNewForm.placementId"
                                               style="width: 240px;">
                                        <el-option v-for="item in placements" :value="item.placementId"
                                                   :label="item.address"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-form>
                        </div>
                        <div v-if="!isNew && !isUpdate">
                            <table style="border-collapse:separate; border-spacing:0px 10px;">
                                <tr>
                                    <td>客户名称</td>
                                    <td class="tdClassForAccount">{{customerName}}</td>
                                </tr>
                                <tr>
                                    <td>联系人</td>
                                    <td class="tdClassForAccount">{{contact}}</td>
                                </tr>
                                <tr>
                                    <td>联系电话</td>
                                    <td class="tdClassForAccount">{{contactNumber}}</td>
                                </tr>
                                <tr>
                                    <td>安装地址</td>
                                    <td class="tdClassForAccount">
                                        <div>{{province}} {{city}} {{district}}</div>
                                        <div>{{address}}</div>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div v-if="isNew || isUpdate">
                            <div style="margin-top: 50px;" v-if="isNew">
                                <el-button @click="newAccount" type="primary">申请开单</el-button>
                            </div>
                            <div style="margin-top: 50px;" v-if="isUpdate">
                                <el-button @click="updateAccount" type="primary">确定修改</el-button>
                            </div>
                        </div>
                        <div v-if="!isNew && !isUpdate">
                            <div>
                                <el-button type="primary" @click="readyUpdate()">修改</el-button>
                            </div>
                            <div v-if="isNeedConfirm">
                                <div style="margin-top: 28px;">
                                    <el-button :loading="loadingForConfirm" @click="confirm(true)" type="success">批准</el-button>
                                </div>
                                <div style="margin-top: 10px;">
                                    <el-button :loading="loadingForConfirm" @click="confirm(false)" type="danger">拒绝</el-button>
                                </div>
                            </div>
                            <div v-if="isSend" style="margin-top: 45px;">
                                <el-button type="primary" @click="openDialog('send')">发货</el-button>
                            </div>
                            <div v-if="isReturn" style="margin-top: 45px;">
                                <el-button type="danger" @click="openDialog('return')">退货</el-button>
                            </div>
                            <div v-if="!isSend && !isNeedConfirm && !isReturn"
                                 style="font-size: 24px;color: red;margin-top: 50px;">
                                <span v-if="status == 1">审批中</span>
                                <span v-if="status == 2">审批通过</span>
                                <span v-if="status == 3">审批拒绝</span>
                                <span v-if="status == 4">已发货</span>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div v-if="!isReturn">
                <el-table ref="productTable" key="productTable" :data="list" style="width: 100%"
                          element-loading-text="数据正在加载中"  :row-style="rowClass"
                          :show-overflow-tooltip="true">
                    <el-table-column prop="modelName" label="设备型号"></el-table-column>
                    <el-table-column label="图片">
                        <template slot-scope="scope">
                            <div>
                                <img :src="scope.row.image" style="width: 30px;height: 30px;" />
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="price" label="费用(元)"></el-table-column>
                    <el-table-column prop="remark" label="备注"></el-table-column>
                    <el-table-column label="数量">
                        <template slot-scope="scope">
                            <div>
                                <el-input v-model="scope.row.quantity" v-if="isNew"></el-input>
                                <span v-if="!isNew">{{scope.row.quantity}}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" v-if="isNew">
                        <template slot-scope="scope">
                            <div>
                                <el-button size="mini" type="danger" @click="deleteItem(scope.$index, list)">删除
                                </el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="margin-top: 10px;text-align: right;" v-if="isNew">
                    <el-button :loading="productLoading" @click="openDialog('add')">添加设备</el-button>
                </div>
                <el-table :data="expressOrderList" style="margin-top: 50px;width: 100%" element-loading-text="数据正在加载中"
                          :row-style="rowClass" :show-overflow-tooltip="true">
                    <el-table-column label="快递公司" prop="expressCompany" />
                    <el-table-column label="快递单号" prop="expressOrderNum" />
                    <el-table-column label="sn" prop="sn" />
                </el-table>
            </div>
            <div v-if="isReturn">
                <el-table ref="returnTable" key="returnTable" :data="returnList" style="width: 100%"
                          @selection-change="returnTableChange" element-loading-text="数据正在加载中"
                           :row-style="rowClass">
                    <el-table-column type="selection" width="60"></el-table-column>
                    <el-table-column prop="sn" label="设备条形码"></el-table-column>
                    <el-table-column prop="model" label="设备型号"></el-table-column>
                    <el-table-column label="图片">
                        <template slot-scope="scope">
                            <div>
                                <img :src="scope.row.image" style="width: 30px;height: 30px;" />
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="expires" label="设备有效期" :formatter="dateFormat"></el-table-column>
                </el-table>
            </div>
            <el-dialog :visible.sync="myDialog" title="选择设备" width="80%">
                <div style="margin: 0 auto;">
                    <el-row type="flex" style="flex-wrap: wrap;" justify="start">
                        <div v-for="item in productList" @click="addProduct(item)">
                            <el-card shadow="hover" style="width: 120px;background-color: #ECECEC;margin: 10px;"
                                     :body-style="{ padding: '0px', height:'180px'}">
                                <div style="text-align: center;font-size: 12px;">
                                    <div class="imgDiv">
                                        <img class="commodityImg" :src="item.image"
                                             onerror="this.src='http://dfs.uarm.lbslm.com/file/cloud/photo/e5799b96340449c49af2409511223e52.jpg';this.onerror=null"
                                             :title="item.price" />
                                    </div>
                                    <div>
                                        <span
                                              style="font-size: 12px;white-space: pre-wrap;">{{item.productName+"\n("+item.modelName+")"}}</span>
                                    </div>
                                </div>
                            </el-card>
                        </div>
                    </el-row>
                </div>
            </el-dialog>
            <el-dialog :visible.sync="myDialog1" width="460px" title="添加设备序列号" :close-on-click-modal="false">
                <el-tabs v-model="activeName">
                    <!--                    <el-tab-pane label="手动输入sn" name="first">-->
                    <!--                        <div>-->
                    <!--                            <el-input type="textarea" style="width: 420px" :rows="7" placeholder="请输入设备出厂的条码号,多个条码号请用英文,分隔" v-model="snValue"></el-input>-->
                    <!--                        </div>-->
                    <!--                        <div style="margin-top: 10px;text-align: right;width: 95%;">-->
                    <!--                            <el-button @click="sendProduct" type="primary">确认发货</el-button>-->
                    <!--                        </div>-->
                    <!--                    </el-tab-pane>-->
                    <el-tab-pane label="输入快递单号和sn" name="first">
                        <div v-for="(es, index) in expressAndSn" style="margin-top: 10px">
                            <el-divider v-if="index > 0" />
                            <div style="display: flex">
                                <el-input v-model="es.expressCompany" placeholder="请输入快递公司" style="width: 150px">
                                </el-input>
                                <el-input v-model="es.expressOrderNum" placeholder="请输入快递单号"
                                          style="width: 210px;margin-left: 10px"></el-input>
                                <el-button type="danger" size="mini" icon="el-icon-delete" style="margin-left: 5px"
                                           circle @click="removeExpressAndSn(index)"></el-button>
                            </div>
                            <div style="margin-top: 5px">
                                <div>
                                    <el-tag style="margin-left: 5px;margin-bottom: 5px;"
                                            v-for="sn in (es.sn.split(','))"
                                            type="info">
                                        {{ sn === '' ? '-' : sn }}
                                    </el-tag>
                                </div>
                                <el-input type="textarea" style="width: 420px" :rows="2" onkeydown="if(event.keyCode==32||event.keyCode==13){return false;}"
                                          placeholder="请输入设备出厂的条码号,多个条码号请用英文,分隔" v-model="es.sn">
                                </el-input>
                            </div>
                        </div>
                        <div style="margin-top: 10px;text-align: right;width: 95%;">
                            <el-button type="primary" @click="addExpress">添加快递单</el-button>
                            <el-button @click="sendProductByExpressOrder" type="primary">确认发货</el-button>
                        </div>
                    </el-tab-pane>
                    <!--                    <el-tab-pane label="上传sn的Excel" name="second">-->
                    <!--                        <el-upload drag :data="uploadData" :on-success="uploadSuccess" :on-error="uploadError" :before-upload="uploadBefore" :action="uploadExcel">-->
                    <!--                            <i class="el-icon-upload"></i>-->
                    <!--                            <div class="el-upload__text">-->
                    <!--                                将文件拖到此处，或-->
                    <!--                                <em>点击上传</em>-->
                    <!--                            </div>-->
                    <!--                            <div class="el-upload__tip" slot="tip" style="color: red;">-->
                    <!--                                只能上传.xls文件,-->
                    <!--                                <a :href="downloadHref" download="sn批量上传模板文件">下载模板文件</a>-->
                    <!--                            </div>-->
                    <!--                        </el-upload>-->
                    <!--                    </el-tab-pane>-->
                </el-tabs>
            </el-dialog>
            <el-dialog :visible.sync="myDialog2" title="退货">
                <div>
                    <el-input type="textarea" style="width: 100%;" :rows="3" placeholder="请输入退货理由"
                              v-model="returnReason"></el-input>
                </div>
                <div style="margin-top: 10px;text-align: right;width: 95%;">
                    <el-button @click="returnProduct" type="primary">确认退货</el-button>
                </div>
            </el-dialog>
            <el-dialog :visible.sync="showExpressOrderDialog" title="快递单">
                <el-table :data="expressOrderList">
                    <el-table-column label="快递公司" prop="expressCompany" />
                    <el-table-column label="快递单号" prop="expressOrderNum" />
                    <el-table-column label="sn" prop="sn" />
                </el-table>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import {
        getAddressList
    } from "../../assets/js/area.js"

    export default {
        name: 'accountRecord',
        components: {},
        data() {
            var validPhone = (rule, value, callback) => {
                // var regPos = /^1[3|4|5|7|8][0-9]{9}$/;
                var regPos = /^1[0-9][0-9]{9}$/;
                if (!regPos.test(value)) {
                    callback(new Error('手机号格式有误!'));
                } else {
                    callback();
                }
            }
            var validSelectList = (rule, value, callback) => {
                if (value.length != 3) {
                    callback(new Error('请完整地选择地址!'));
                } else {
                    callback();
                }
            }
            return {
                addressList: [],
                commodityProps: {
                    value: 'label',
                    label: 'label'
                },
                accountNewForm: {
                    selectList: [],
                    address: '',
                    customerName: '',
                    contact: '',
                    contactNumber: '',
                    businessModel: '',
                    placementId: ''
                },
                accountNewRules: {
                    businessModel: [{
                        trigger: 'blur',
                        required: true,
                        message: '开单类型不能为空!'
                    }],
                    selectList: [{
                        trigger: 'change',
                        required: true,
                        message: '请选择地址!'
                    }, {
                        trigger: 'change',
                        validator: validSelectList
                    }],
                    address: [{
                        trigger: 'blur',
                        required: true,
                        message: '详细地址不能为空!'
                    }],
                    placementId: [{
                        trigger: 'blur',
                        required: true,
                        message: '详细地址不能为空!'
                    }],
                    customerName: [{
                        trigger: 'blur',
                        required: true,
                        message: '客户名称不能为空!'
                    }],
                    contact: [{
                        trigger: 'blur',
                        required: true,
                        message: '联系人不能为空!'
                    }],
                    contactNumber: [{
                        trigger: 'blur',
                        required: true,
                        message: '联系人手机号不能为空!'
                    }, {
                        trigger: 'blur',
                        validator: validPhone
                    }]
                },
                total: 0,
                currentPage: 1,
                pageSize: 10,
                tableData: [],
                multipleSelection: [],
                myDialog: false,
                myDialog1: false,
                uploadData: {
                    id: ""
                },
                isFirst: true,
                statusSelect: "0",
                selectValue: "",
                queryValue: "",
                time: [],
                isAgent: false,
                isBrand: false,
                title: "新建开单",
                isNew: true,
                customerName: "",
                id: "",
                address: "",
                city: "",
                contact: "",
                contactNumber: "",
                district: "",
                province: "",
                list: [],
                productLoading: false,
                productList: [],
                status: "",
                isNeedConfirm: true,
                isSend: true,
                snValue: '',
                isReturn: false,
                returnList: [],
                returnSelection: [],
                myDialog2: false,
                returnReason: "",
                activeName: 'first',
                uploadExcel: this.$store.getters.getApiValue + "/application/shipByExcel.do",
                downloadHref: this.$store.getters.getApiValue + "/UploadTemplate.xls",
                placements: [],
                businessModelList: [],
                expressAndSn: [{
                    expressOrderNum: '',
                    expressCompany: '',
                    sn: '',
                }],
                showExpressOrderDialog: false,
                expressOrderList: [],
                isUpdate: false,
                loadingForConfirm:false
            }
        },
        watch: {},
        computed: {
            isInput: function() {
                if (this.selectValue != "5") {
                    this.queryValue = "";
                    return true;
                } else {
                    return false;
                }
            }
        },
        mounted() {
            var thiz = this;
            axios.get(this.$store.getters.getApiValue + '/srsUser/getMyData.do').then(function(response) {
                var data = response.data;
                if (data.status == "200") {
                    if (data.data.role == "2" || data.data.role == "3" || data.data.role == "8" || data.data
                        .role == "9") {
                        thiz.isAgent = true;
                    } else if (data.data.role == "4") {
                        thiz.isBrand = true;
                    }
                } else {
                    thiz.$message.error(data.message);
                }
            }).catch(function(error) {
                thiz.$message.error("系统异常，请与管理员联系!");
                console.log(error);
            });
            this.allBusinessModel();
            this.updateTable();
        },
        beforeDestroy() {},
        methods: {
            handleChange(value) {
                console.log(value);
                var thiz = this;
                if (thiz.accountNewForm.businessModel != 4) {
                    return;
                }
                axios.get(this.$store.getters.getApiValue + '/placement/list.do', {
                    params: {
                        province: value[0],
                        city: value[1],
                        district: value[2]
                    }
                }).then(function(response) {
                    var data = response.data;
                    if (data.status == "200") {
                        thiz.placements = data.data;
                    } else {
                        thiz.$message.error(data.message);
                    }
                }).catch(function(error) {
                    thiz.$message.error("系统异常，请与管理员联系!");
                    console.log(error);
                });
            },
            allConfirm(flag) {
                var ids = "";
                for (var i = 0; i < this.multipleSelection.length; i++) {
                    if (this.multipleSelection[i].status == "1") {
                        ids = ids + this.multipleSelection[i].id + ",";
                    }
                }
                if (ids.length <= 0) {
                    this.$message.error("请选择需审批的单!");
                    return;
                }
                var thiz = this;
                var str = "";
                if (flag) {
                    str = "确认批量批准单号为"
                } else {
                    str = "确认批量拒绝单号为"
                }
                this.$confirm(str + ids.substring(0, ids.length - 1) + '吗?')
                    .then(_ => {
                        thiz.loadingForConfirm=true;
                        axios.get(thiz.$store.getters.getApiValue + '/application/verify.do', {
                            params: {
                                ids: ids.substring(0, ids.length - 1),
                                ispass: flag
                            }
                        }).then(function(response) {
                            var data = response.data;
                            if (data.status == "200") {
                                thiz.$message.success("审批开单成功!");
                                thiz.updateTable();
                            } else {
                                thiz.$message.error(data.message);
                            }
                            thiz.loadingForConfirm=false;
                        }).catch(function(error) {
                            thiz.$message.error("系统异常，请与管理员联系!");
                            console.log(error);
                            thiz.loadingForConfirm=false;
                        });
                    }).catch(_ => {});
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            returnTableChange(val) {
                this.returnSelection = val;
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.updateTable();
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.updateTable();
            },
            statusChange() {
                this.updateTable();
            },
            updateTable() {
                var params = {
                    pageId: this.currentPage,
                    size: this.pageSize
                };
                if (this.statusSelect != "0") {
                    params.status = this.statusSelect
                }
                if (this.selectValue == "1" && this.queryValue != "") {
                    params.adminName = this.queryValue;
                } else if (this.selectValue == "2" && this.queryValue != "") {
                    params.contact = this.queryValue;
                } else if (this.selectValue == "3" && this.queryValue != "") {
                    params.customerName = this.queryValue;
                } else if (this.selectValue == "4" && this.queryValue != "") {
                    params.id = this.queryValue;
                } else if (this.selectValue == "5") {
                    if (this.time != null && this.time.length > 0) {
                        params.startDate = this.getStandardDate(this.time[0]);
                        params.endDate = this.getStandardDate(this.time[1]);
                    }
                } else if (this.selectValue === '6') {
                    params.address = this.queryValue
                }
                const loading = this.$loading({
                    lock: true,
                    text: '获取表格数据中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                setTimeout(() => {
                    loading.close();
                }, 3000);
                var thiz = this;
                axios.get(this.$store.getters.getApiValue + '/application/searche.do', {
                    params: params
                }).then(function(response) {
                    loading.close();
                    var data = response.data;
                    if (data.status == "200") {
                        thiz.total = data.totalCount;
                        thiz.tableData = data.data;
                    } else {
                        thiz.$message.error(data.message);
                    }
                }).catch(function(error) {
                    loading.close();
                    thiz.$message.error("系统异常，请与管理员联系!");
                    console.log(error);
                });
            },
            goback() {
                if(this.isUpdate){
                    this.isUpdate=false;
                    return;
                }
                this.isFirst = true;
                this.isNeedConfirm = true;
                this.isSend = true;
                this.isReturn = false;
                this.customerName = "";
                this.id = "";
                this.address = "";
                this.city = "";
                this.contact = "";
                this.contactNumber = "";
                this.district = "";
                this.province = "";
                this.status = "";
                this.productList = [];
                this.list = [];
                this.returnReason = "";
                this.updateTable();
            },
            readyNewAccount() {
                this.isReturn = false;
                this.title = "新建开单";
                this.addressList = getAddressList();
                this.list = [];
                this.accountNewForm.selectList = [];
                this.accountNewForm.contact = "";
                this.accountNewForm.customerName = "";
                this.accountNewForm.contactNumber = "";
                this.accountNewForm.businessModel = "";
                this.isNew = true;
                this.isFirst = false;
                // var thiz = this;
                // axios.get(this.$store.getters.getApiValue+'/application/skuList.do')
                // 	.then(function (response) {
                // 	    var data = response.data;
                // 	    if(data.status == "200"){
                // 	    	thiz.productList = data.data;
                // 	    	thiz.isNew = true;
                // 	    	thiz.isFirst = false;
                // 	    }else{
                // 			thiz.$message.error(data.message);
                // 		}
                //   }).catch(function (error) {
                //   	thiz.$message.error("系统异常，请与管理员联系!");
                //     console.log(error);
                //   });
            },
            getMessage(row) {
                this.isNew = false;
                this.isUpdate = false;
                this.isReturn = false;
                this.title = "查看详情";
                this.list = [];
                var thiz = this;
                axios.get(this.$store.getters.getApiValue + '/application/get.do', {
                    params: {
                        id: row.id
                    }
                }).then(function(response) {
                    var data = response.data;
                    if (data.status == "200") {
                        thiz.id = data.data.id;
                        thiz.address = data.data.address;
                        thiz.city = data.data.city;
                        thiz.contact = data.data.contact;
                        thiz.contactNumber = data.data.contactNumber;
                        thiz.customerName = data.data.customerName;
                        thiz.district = data.data.district;
                        thiz.province = data.data.province;
                        thiz.status = data.data.status;
                        if (data.data.status == "1" && !thiz.isAgent) {
                            thiz.isNeedConfirm = true;
                        } else {
                            thiz.isNeedConfirm = false;
                        }
                        if (data.data.status == "2" && !thiz.isAgent) {
                            thiz.isSend = true;
                        } else {
                            thiz.isSend = false;
                        }
                        var jsonList = JSON.parse(data.data.json);
                        for (var i = 0; i < jsonList.length; i++) {
                            thiz.list.push(jsonList[i]);
                        }
                        thiz.isNew = false;
                        thiz.isFirst = false;
                    } else {
                        thiz.$message.error(data.message);
                    }
                }).catch(function(error) {
                    thiz.$message.error("系统异常，请与管理员联系!");
                    console.log(error);
                });

                axios.get(this.$store.getters.getApiValue + '/application/listExpressOrder.do', {
                    params: {
                        id: row.id,
                    }
                }).then(function(response) {
                    thiz.expressOrderList = response.data.data
                    //console.log(response, 'expressOrder Response')
                    //thiz.showExpressOrderDialog = true;
                }).catch(function(error) {
                    thiz.$message.error("系统异常，请与管理员联系!");
                    console.log(error);
                });


                //this.showExpressOrder();
            },
            returnAccount(row) {
                this.isReturn = true;
                this.isNeedConfirm = false;
                this.isSend = false;
                this.returnList = [];
                this.id = row.id;
                this.address = row.address;
                this.city = row.city;
                this.contact = row.contact;
                this.contactNumber = row.contactNumber;
                this.customerName = row.customerName;
                this.district = row.district;
                this.province = row.province;
                this.status = row.status;
                this.title = "查看详情";
                var thiz = this;
                axios.get(this.$store.getters.getApiValue + '/application/listReturnDevice.do', {
                    params: {
                        applicationId: row.id
                    }
                }).then(function(response) {
                    var data = response.data;
                    if (data.status == "200") {
                        thiz.returnList = data.data;
                        thiz.isNew = false;
                        thiz.isFirst = false;
                    } else {
                        thiz.$message.error(data.message);
                    }
                }).catch(function(error) {
                    thiz.$message.error("系统异常，请与管理员联系!");
                    console.log(error);
                });
            },
            cancelAccount(row) {
                var thiz = this;

                this.$confirm('此操作将永久取消该单, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios.get(this.$store.getters.getApiValue + '/application/cancel.do', {
                        params: {
                            ids: row.id
                        }
                    }).then(function(response) {
                        var data = response.data;
                        if (data.status == "200") {
                            thiz.$message.success("操作成功!");
                            thiz.updateTable();
                        } else {
                            thiz.$message.error(data.message);
                        }
                    }).catch(function(error) {
                        thiz.$message.error("系统异常，请与管理员联系!");
                        console.log(error);
                    });
                }).catch(() => {});
            },
            dateFormat(row, column, cellValue, index) {
                var str = cellValue;
                if (str == null || str == "") {
                    return "";
                } else {
                    return this.getStandardDate(new Date(str));
                }
            },
            getStandardDate(val) {
                var year = val.getFullYear();
                var month = val.getMonth() + 1;
                var day = val.getDate();
                month = month < 10 ? "0" + month : month;
                day = day < 10 ? "0" + day : day;
                return year + "-" + month + "-" + day;
            },
            rowClass({
                row,
                rowIndex
            }) {
                if (rowIndex % 2 == 0) {
                    return 'background:#F1F2F7;'
                } else {
                    return 'background:white;'
                }
                return ''
            },
            newAccount() {
                var thiz = this;
                this.$refs["accountNewForm"].validate(async valid => {
                    if (valid) {
                        if (this.list.length <= 0) {
                            this.$message.error("设备列表为空,请添加开单所需的设备!");
                            this.myDialog = true;
                            return;
                        } else {
                            for (var i = 0; i < this.list.length; i++) {
                                if (this.list[i].quantity <= 0) {
                                    this.$message.error("设备" + this.list[i].modelName + "的数量不能小于0!");
                                    return;
                                }
                            }
                        }
                        axios.get(this.$store.getters.getApiValue +
                            `/application/create.do?businessModel=${this.accountNewForm.businessModel}`, {
                                params: {
                                    address: thiz.accountNewForm.address,
                                    city: thiz.accountNewForm.selectList[1],
                                    contact: thiz.accountNewForm.contact,
                                    contactNumber: thiz.accountNewForm.contactNumber,
                                    customerName: thiz.accountNewForm.customerName,
                                    district: thiz.accountNewForm.selectList[2],
                                    json: JSON.stringify(thiz.list),
                                    province: thiz.accountNewForm.selectList[0],
                                    placementId: thiz.accountNewForm.placementId == '' ? 0 : thiz
                                        .accountNewForm.placementId
                                }
                            }).then(function(response) {
                            var data = response.data;
                            if (data.status == "200") {
                                thiz.updateTable();
                                thiz.isFirst = true;
                            } else {
                                thiz.$message.error(data.message);
                            }
                        }).catch(function(error) {
                            thiz.$message.error("系统异常，请与管理员联系!");
                            console.log(error);
                        });
                    } else {
                        this.$message.error("填写不完整或格式不正确，请确认！")
                    }
                })
            },
            addProduct(product) {
                var flag = true;
                for (var i = 0; i < this.list.length; i++) {
                    if (product.mid == this.list[i].mid) {
                        this.list[i].quantity = this.list[i].quantity + 1;
                        flag = false;
                    }
                }
                if (flag) {
                    var item = {
                        productId: product.productId,
                        modelName: product.modelName,
                        price: product.price,
                        quantity: 1,
                        mid: product.mid,
                        image: product.image,
                        remark: product.remark
                    }
                    this.list.push(item);
                }
                this.myDialog = false;
            },
            openDialog(method) {
                if (method == "add") {
                    this.$refs.accountNewForm.validateField("businessModel", (error) => {
                        console.log(error)
                        if (error) {

                        } else {
                            this.myDialog = true;
                        }
                    })
                } else if (method == "send") {
                    this.uploadData.id = this.id;

                    this.myDialog1 = true;
                } else if (method == 'return') {
                    if (this.returnSelection.length <= 0) {
                        this.$message.error("退货设备为空,请选择需退货的设备!");
                        return;
                    }
                    this.myDialog2 = true;
                }
            },
            confirm(flag) {
                var thiz = this;
                thiz.loadingForConfirm=true;
                axios.get(this.$store.getters.getApiValue + '/application/verify.do', {
                    params: {
                        ids: thiz.id,
                        ispass: flag
                    }
                }).then(function(response) {
                    var data = response.data;
                    if (data.status == "200") {
                        if (flag) {
                            thiz.isNeedConfirm = false;
                            thiz.isSend = true;
                        } else {
                            thiz.status = "3";
                            thiz.isNeedConfirm = false;
                            thiz.isSend = false;
                        }
                         thiz.$message.success("审批开单成功!");
                    } else {
                        thiz.$message.error(data.message);
                    }
                    thiz.loadingForConfirm=false;
                }).catch(function(error) {
                    thiz.$message.error("系统异常，请与管理员联系!");
                    console.log(error);
                    thiz.loadingForConfirm=false;
                });
            },
            sendProduct() {
                var thiz = this;
                axios.get(this.$store.getters.getApiValue + '/application/ship.do', {
                    params: {
                        id: thiz.id,
                        sn: thiz.snValue
                    }
                }).then(function(response) {
                    var data = response.data;
                    if (data.status == "200") {
                        thiz.status = "4";
                        thiz.isNeedConfirm = false;
                        thiz.myDialog1 = false;
                        thiz.isSend = false;
                    } else {
                        thiz.$message.error(data.message);
                    }
                }).catch(function(error) {
                    thiz.$message.error("系统异常，请与管理员联系!");
                    console.log(error);
                });
            },
            returnProduct() {
                var thiz = this;
                if (this.returnReason == "") {
                    this.$message.error("请填写设备退货理由!");
                    return;
                }
                axios.get(this.$store.getters.getApiValue + '/application/returnedPurchase.do', {
                    params: {
                        id: thiz.id,
                        reason: thiz.returnReason,
                        json: JSON.stringify(thiz.returnSelection)
                    }
                }).then(function(response) {
                    var data = response.data;
                    if (data.status == "200") {
                        thiz.myDialog2 = false;
                        thiz.goback();
                    } else {
                        thiz.$message.error(data.message);
                    }
                }).catch(function(error) {
                    thiz.$message.error("系统异常，请与管理员联系!");
                    console.log(error);
                });
            },
            uploadSuccess(res, file, fileList) {
                if (res.status == 200) {
                    if (res.data) {
                        this.$message.success("上传成功!");
                        this.status = "4";
                    } else {
                        this.$message.error("上传失败!");
                    }
                    this.myDialog1 = false;
                } else {
                    this.$message.error(res.message);
                    this.myDialog1 = false;
                }
            },
            uploadError(err, file, fileList) {
                this.myDialog1 = false;
                thiz.$message.error("系统异常，请与管理员联系!");
                cosole.log(err);
            },
            uploadBefore(file) {
                var flag = file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "xls";
                if (!flag) {
                    this.$message.error("上传文件不是.xls类型文件");
                }
                return flag;
            },
            deleteItem(index, rows) {
                rows.splice(index, 1);
            },
            switchModel() {
                this.list = [];
                this.productList = [];
                if (this.accountNewForm.businessModel == 4 && this.accountNewForm.placementId == '') {
                    return;
                };
                this.productLoading = true
                axios.get(this.$store.getters.getApiValue + '/application/skuList.do', {
                        params: {
                            businessModel: this.accountNewForm.businessModel,
                            placementId: this.accountNewForm.placementId == '' ? 0 : this.accountNewForm
                                .placementId,
                        }
                    })
                    .then((response) => {
                        var data = response.data;
                        if (data.status == "200") {
                            this.productList = data.data;
                        } else {
                            this.$message.error(data.message);
                        }
                    }).catch(function(error) {
                        thiz.$message.error("系统异常，请与管理员联系!");
                        console.log(error);
                    })
                    .finally(() => {
                        this.productLoading = false
                    })
            },
            allBusinessModel() {
                var thiz = this;
                axios.get(this.$store.getters.getApiValue + '/application/allBusinessModel.do', {
                    params: {}
                }).then(function(response) {
                    var data = response.data;
                    if (data.status == "200") {
                        console.log(data);
                        thiz.businessModelList = data.data;
                    } else {
                        thiz.$message.error(data.message);
                    }
                }).catch(function(error) {
                    thiz.$message.error("系统异常，请与管理员联系!");
                    console.log(error);
                });
            },
            addExpress() {
                this.expressAndSn.push({
                    expressCompany: '',
                    expressOrderNum: '',
                    sn: '',
                })
            },
            removeExpressAndSn(index) {
                this.expressAndSn.splice(index, 1);
            },
            sendProductByExpressOrder() {
                for(var i=0;i<this.expressAndSn.length;i++){
                    this.expressAndSn[i].sn=this.expressAndSn[i].sn.replace(/\ +/g,"").replace(/[\r\n]/g,"")
                }
                var thiz = this;
                axios.get(this.$store.getters.getApiValue + '/application/ship.do', {
                    params: {
                        id: thiz.id,
                        expressOrder: JSON.stringify(this.expressAndSn)
                    }
                }).then(function(response) {
                    var data = response.data;
                    if (data.status == "200") {
                        thiz.status = "4";
                        thiz.isNeedConfirm = false;
                        thiz.myDialog1 = false;
                        thiz.isSend = false;
                        thiz.showExpressOrder();
                        thiz.expressAndSn = [{
                            expressOrderNum: '',
                            expressCompany: '',
                            sn: '',
                        }]
                    } else {
                        thiz.$message.error(data.message);
                    }
                }).catch(function(error) {
                    thiz.$message.error("系统异常，请与管理员联系!");
                    console.log(error);
                });
            },
            showExpressOrder() {
                var thiz = this;
                axios.get(this.$store.getters.getApiValue + '/application/listExpressOrder.do', {
                    params: {
                        id: thiz.id,
                    }
                }).then(function(response) {
                    thiz.expressOrderList = response.data.data
                    //console.log(response, 'expressOrder Response')
                    //thiz.showExpressOrderDialog = true;
                }).catch(function(error) {
                    thiz.$message.error("系统异常，请与管理员联系!");
                    console.log(error);
                });
            },
            readyUpdate() {
                this.isUpdate = true;
                this.addressList = getAddressList();
                this.accountNewForm.customerName = this.customerName;
                this.accountNewForm.contact = this.contact;
                this.accountNewForm.contactNumber = this.contactNumber;
                //this.accountNewForm.selectList =
                this.accountNewForm.address = this.address;
                let loc = [this.province, this.city, this.district];
                this.accountNewForm.selectList = loc;
            },
            updateAccount() {
                var thiz = this;
                axios.get(this.$store.getters.getApiValue + '/application/update.do', {
                    params: {
                        id: thiz.id,
                        customerName: thiz.accountNewForm.customerName,
                        contact: thiz.accountNewForm.contact,
                        contactNumber: thiz.accountNewForm.contactNumber,
                        province: thiz.accountNewForm.selectList[0],
                        city: thiz.accountNewForm.selectList[1],
                        district: thiz.accountNewForm.selectList[2],
                        address: thiz.accountNewForm.address
                    }
                }).then(function(response) {
                    var data = response.data;
                    if (data.status == "200") {
                        //thiz.updateTable();
                        //thiz.isFirst = true;
                        thiz.isUpdate = false;
                        thiz.getModel();
                    } else {
                        thiz.$message.error(data.message);
                    }
                }).catch(function(error) {
                    thiz.$message.error("系统异常，请与管理员联系!");
                    console.log(error);
                });
            },
            getModel() {
                var thiz = this;
                axios.get(this.$store.getters.getApiValue + '/application/get.do', {
                    params: {
                        id: thiz.id
                    }
                }).then(function(response) {
                    var data = response.data;
                    if (data.status == "200") {
                        thiz.address = data.data.address;
                        thiz.city = data.data.city;
                        thiz.contact = data.data.contact;
                        thiz.contactNumber = data.data.contactNumber;
                        thiz.customerName = data.data.customerName;
                        thiz.district = data.data.district;
                        thiz.province = data.data.province;
                    } else {
                        thiz.$message.error(data.message);
                    }
                }).catch(function(error) {
                    thiz.$message.error("系统异常，请与管理员联系!");
                    console.log(error);
                });
            }
        }
    }
</script>

<style>
    .el-table {
        font-size: 12px;
        border-bottom: 1px solid #dcd8d8;
        color: black;
    }

    .el-table tr th {
        border-top: 0px;
        border-left: 0px;
        border-right: 0px;
    }

    .el-table tr td {
        border-bottom: 1px solid #dcd8d8;
    }

    .tdClassForAccount {
        padding-left: 10px;
    }

    .imgDiv .commodityImg {
        width: 120px;
        height: 120px;
    }

    .el-table .cell {
        white-space: pre-wrap;
    }
</style>